<h1>
  Scénario préprogrammé : <strong>{{ data.sp.nom }}</strong>
</h1>

<kendo-grid
  #kendoGrid
  [data]="gridWrapper.gridData"
  kendoGridSelectBy="id"
  [height]="height"
  scrollable="virtual"
  rowHeight="54px"
  [skip]="gridWrapper.gridState.skip"
  [pageSize]="gridWrapper.gridState.take"
  (dataStateChange)="gridWrapper.onDataStateChange($event)"
>
  <kendo-grid-column field="nom" title="Nom" [editable]="false"> </kendo-grid-column>
  <kendo-grid-column field="actif" title="Active" width="120">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="icon-container">
        <mat-icon [style.color]="dataItem.actif ? 'green' : 'yellow'">{{ dataItem.actif ? 'check_circle' : 'pause_circle' }}</mat-icon>
      </div>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Actions" width="120" editor="boolean">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button color="primary" mat-icon-button (click)="toggleActif(rowIndex, !dataItem.actif)">
        <mat-icon>not_started</mat-icon>
      </button>
    </ng-template>
  </kendo-grid-column>
</kendo-grid>

<section fxLayout="row" fxLayoutAlign="space-between">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!isFormDirty">Enregistrer</button>
    <mat-spinner style="margin-left: 10px" color="primary" [diameter]="20" *ngIf="saving"></mat-spinner>
  </div>

  <button mat-raised-button color="accent" (click)="cancelChanges()">Annuler</button>
</section>
